import { render } from "./ContactUs.vue?vue&type=template&id=523f4d38&scoped=true"
const script = {}

import "./ContactUs.vue?vue&type=style&index=0&id=523f4d38&scoped=true&lang=css"

import exportComponent from "D:\\projectLinkoffer\\green-lit-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-523f4d38"]])

export default __exports__